import { render, staticRenderFns } from "./CustomEditor.vue?vue&type=template&id=697f344b&scoped=true&"
import script from "./CustomEditor.vue?vue&type=script&lang=js&"
export * from "./CustomEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomEditor.vue?vue&type=style&index=0&id=697f344b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f344b",
  null
  
)

export default component.exports